import React, { useState } from "react";
// import { MagnifyingGlass, PencilSimple} from "phosphor-react";
// import abc_2 from "../helper/images/abc_2.png";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import NewHeader from "../helper/NewHeader";

function LanguageListFour() {
  // const [show, setShow] = useState(false);
  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  const [value, setValue] = useState('');
  return (
    <>
     <NewHeader/>
      <main role="main" className="contentarea">        
        <section className="second textBtn">
          <div className="container">
            <div className="row">
                <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xxl-9">
                <div className="bg-white pb-3 mb-4 leftBox">
                <ReactQuill theme="snow" value={value} onChange={setValue}  />
                <div className="editBtn mt-2 pl-3">
                <a href="javascript:void(0)">Alternate</a>
                <a href="javascript:void(0)">Set Tone</a>
                <a href="javascript:void(0)">Add to dictionary</a>
                <a href="javascript:void(0)">Summarize</a>
                </div>
                </div>
                </div>
                <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                    <div className="bg-white p-3 rightBox">
                      <div className="editBtn">
                       <a href="#">Alternate 1</a>
                       </div>
                       <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the 
                        industry's when an unknown printer took a galley of type and 
                        scrambled it to make a type specimen book.</p>
                        <div className="editBtn">
                       <a href="#">Alternate 2</a>
                       </div>
                       <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the 
                        industry's when an unknown printer took a galley of type and 
                        scrambled it to make a type specimen book.</p>
                        <div className="editBtn text-end mt-4">
                       <a href="#">Click to replace</a>
                       </div>
                    </div>
                </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default LanguageListFour;
